// IPv4 validation regex - STRICT 4 octets only (0-255 per octet)
const IPV4_REGEX = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const validateIPv4 = (ip: string): boolean => {
  return IPV4_REGEX.test(ip);
};

export const formatIPInput = (text: string): string => {
  // Allow only numbers and dots
  const formatted = text.replace(/[^0-9.]/g, '');
  
  // Prevent more than 3 dots
  const parts = formatted.split('.');
  if (parts.length > 4) {
    return parts.slice(0, 4).join('.');
  }
  
  // Prevent each octet from exceeding 255
  const validParts = parts.map(part => {
    if (part === '') return '';
    const num = parseInt(part, 10);
    return num > 255 ? '255' : part;
  });
  
  return validParts.join('.');
};

// Auto-calculate network IP from gateway IP and subnet mask
export const calculateNetworkIP = (gatewayIP: string, subnetMask: string): string => {
  if (!validateIPv4(gatewayIP) || !validateIPv4(subnetMask)) {
    return '';
  }

  const ipParts = gatewayIP.split('.').map(Number);
  const maskParts = subnetMask.split('.').map(Number);
  
  const networkParts = ipParts.map((octet, index) => octet & maskParts[index]);
  
  return networkParts.join('.');
};

// Timezone mapping: Human-readable location -> FortiOS Timezone ID
export const TIMEZONE_MAP: Record<string, string> = {
  // Europe
  'Europe/Rome': '28',
  'Europe/London': '26',
  'Europe/Paris': '29',
  'Europe/Berlin': '4',
  'Europe/Madrid': '55',
  'Europe/Amsterdam': '1',
  'Europe/Brussels': '7',
  'Europe/Vienna': '77',
  'Europe/Zurich': '85',
  'Europe/Stockholm': '68',
  
  // Americas
  'America/New_York': '12',
  'America/Los_Angeles': '47',
  'America/Chicago': '8',
  'America/Toronto': '71',
  'America/Mexico_City': '50',
  'America/Sao_Paulo': '65',
  'America/Buenos_Aires': '6',
  
  // Asia
  'Asia/Tokyo': '54',
  'Asia/Shanghai': '67',
  'Asia/Hong_Kong': '21',
  'Asia/Singapore': '66',
  'Asia/Dubai': '14',
  'Asia/Mumbai': '24',
  'Asia/Bangkok': '70',
  'Asia/Seoul': '57',
  
  // Pacific
  'Australia/Sydney': '3',
  'Australia/Melbourne': '49',
  'Pacific/Auckland': '53',
  
  // Africa
  'Africa/Johannesburg': '27',
  'Africa/Cairo': '9',
};

export const getTimezoneOptions = (): Array<{ label: string; value: string }> => {
  return Object.keys(TIMEZONE_MAP).map((location) => ({
    label: location.replace(/_/g, ' '),
    value: location,
  }));
};
